export enum AdditionalWeeksReason {
    ManualLabor = 10,
    Complications = 20,
    Other = 100
}